import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import MainContainer from './MainContainer';

function App() {
  
  return (
    <Router>
      <MainContainer />
    </Router>
  );
}

export default App;
